import React,{Component,Fragment, useEffect} from 'react';
import Slider from 'react-slick'
import '../../styles/cardslider.css'
import pic from '../../styles/nynfc_bg2.jpg'

 const App =()=> {

  let array = [1,2,3,4,5,6,7,8,9,10]

  useEffect(()=>{
   let array=document.querySelectorAll('.player-personal-img')
   array.forEach(ele=>(ele.style.backgroundImage = `url(${pic})`))
  },[])

    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div className="container-fluid container-fluid-bg">
      <div className="container container-background">
        <Slider {...settings}>
          {array.map(index=>(
            <div className="player-card">
            <div className="player-personal-img" style={{height:"200px"}} ></div>
            <div className="player-personal-content">
                <h3>Binamra Khadkha</h3>
                <p>Forward</p>
                  <h1>{index}</h1>
                <div className="player-personal-social-nt">
                  <div className="social-links">
                    <i className="fab fa-facebook-square facebook-color"></i>
                    <i className="fab fa-twitter-square twitter-color"></i>
                    <i className="fab fa-instagram instagram-color"></i>
                  </div>
                </div>
            </div>
          </div>
          ))}
        </Slider>
      </div>
    </div>

    );
}

export default App;